import createUseStyles from './create/index.js';
import { Transitions } from './enums/index.js';

var useStyles = createUseStyles({
  '@keyframes roll': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    backgroundColor: function backgroundColor(props) {
      return props.backgroundColor;
    },
    '&.fullscreen': {
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1000,
      '& > $icon': {
        width: 44,
        height: 44
      }
    },
    '&.static': {
      minHeight: 32,
      minWidth: 32,
      '& > $icon': {
        width: 32,
        height: 32
      }
    },
    '&.cover': {
      minHeight: 32,
      minWidth: 32,
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 1,
      '& > $icon': {
        width: 32,
        height: 32
      }
    }
  },
  icon: {
    display: 'inline-block',
    '& > svg': {
      animation: "$roll ".concat(Transitions.Long, " linear infinite")
    }
  }
}, {
  name: 'loading'
});

export { useStyles as u };
//# sourceMappingURL=styles-qFhAELWS.js.map
